module.exports = __webpack_public_path__ + "static/media/YF78_1.13e33318.jpg";